export default {
  login_mfa: {
    title: '@:login.title',
    message: 'To the SMS of your registered phone number We have sent you an authentication code.\nEnter the authentication code, Press the login button.\nThe expiration time is 5 minutes.',
    button_submit: '@:login.login',
    button_resend: 'Resend authentication code',
    alert_success: 'Resend authentication code.',
    alert_error: 'Authentication code has been resent.',
    error: '@:common.error.code_9999',
    no_phone_number_message: "SMS authentication could not be carried out because the logged-in user did not have a phone number registered.\n\nContact your company's account administrator and ask them to register your telephone number.",
  },
}
